import Vue from "vue";
import "./plugins/vuetify";
import Vuetify from "vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

Vue.config.productionTip = false;

// Components import
import Header from "./components/partials/Header.vue";

// Views imported
import About from "./views/About.vue";

// Vuetify import
import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

if (document.getElementById("header") !== null) {
  new Vue({
    router,
    store,
    render: h => h(Header)
  }).$mount("#header");
}

if (document.getElementById("about") !== null) {
  new Vue({
    router,
    store,
    render: h => h(About)
  }).$mount("#about");
}
